<div class="search-user-input">
  <input class="form-control lna" #searchInput [(ngModel)]="value" [ngClass]="{ invalid: invalid }"
    (input)="onChange($event)" (focus)="onFocus()" type="text" placeholder="Meklēt darbinieku" />
  <button class="clear-search" (click)="clearSearch()" type="button">
    <img src="assets/images/close-icon.svg" alt="clear" />
  </button>
  @if (users.length > 0 && isActive) {
  <div class="select-user-dropdown" #dropdown>
    @for (user of users; track user.id; let i = $index) {
    <button class="user-item" (click)="selectUser(user)" [ngClass]="{ 'focused': i === focusedIndex }">
      {{ getUserDisplayName(user) }}
    </button>
    }
  </div>
  }
  @if (isLoading) {
  <div class="spinner-wrapper">
    <div class="spinner"></div>
  </div>
  }
</div>
